import GraphModal from 'graph-modal';

function initRequestModal() {
    if (!document.querySelector('.graph-modal')) {
        return;
    }

    new GraphModal();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRequestModal);
} else {
    initRequestModal();
}
